import { render, staticRenderFns } from "./OpenMember.vue?vue&type=template&id=48a3e913&scoped=true&"
import script from "./OpenMember.vue?vue&type=script&lang=js&"
export * from "./OpenMember.vue?vue&type=script&lang=js&"
import style0 from "./OpenMember.vue?vue&type=style&index=0&id=48a3e913&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3e913",
  null
  
)

export default component.exports